import type { IComponentAjax, IComponentAjaxState } from "@Components/ComponentAjax";
import { ComponentAjax } from "@Components/ComponentAjax";
import { Loading } from "@Components/Loading";

import { DiscountCouponType } from "./DiscountCouponBase";
import type { IDiscountCouponImage } from "./DiscountCouponImage";
import { DiscountCouponImage } from "./DiscountCouponImage";
import type { IDiscountCouponLink } from "./DiscountCouponLink";
import { DiscountCouponLink } from "./DiscountCouponLink";
import type { IDiscountCouponMobileOnly } from "./DiscountCouponMobileOnly";
import { DiscountCouponMobileOnly } from "./DiscountCouponMobileOnly";
import type { IDiscountCouponCode } from "./DiscountCoupons";
import { DiscountCouponCode } from "./DiscountCoupons";

interface IDiscountCouponResult
    extends IDiscountCouponCode,
        IDiscountCouponLink,
        IDiscountCouponImage,
        IDiscountCouponMobileOnly {
    couponType: DiscountCouponType;
}

export interface IDiscountCoupon extends IComponentAjax<IDiscountCouponResult> {}

interface IDiscountCouponState extends IComponentAjaxState {
    coupon?: IDiscountCouponResult;
}

export class DiscountCoupon extends ComponentAjax<
    IDiscountCouponResult,
    IDiscountCoupon,
    IDiscountCouponState
> {
    constructor(props: IDiscountCoupon) {
        super(props);
        this.state = {
            isLoading: !this.props.initialData,
            coupon: this.props.initialData,
        };
    }

    public componentDidMount() {
        if (this.state.coupon) {
            return;
        }

        this.ajaxRequest();
    }

    public render() {
        if (this.state.isLoading === true) {
            return <Loading />;
        }

        if (this.state.coupon) {
            const discountProps = { ...this.state.coupon };

            switch (this.state.coupon.couponType) {
                case DiscountCouponType.Code:
                    return <DiscountCouponCode {...discountProps} />;
                case DiscountCouponType.Link:
                    return <DiscountCouponLink {...discountProps} />;
                case DiscountCouponType.Image:
                    return <DiscountCouponImage {...discountProps} />;
                case DiscountCouponType.MobileOnly:
                    return <DiscountCouponMobileOnly {...discountProps} />;
                default:
                    return null;
            }
        }

        return null;
    }

    protected ajaxSuccess(response: IDiscountCouponResult) {
        if (!response) {
            this.setState({ isLoading: false, coupon: undefined });
            return;
        }

        this.setState({ isLoading: false, coupon: response });
    }

    protected ajaxFail() {
        this.setState({ isLoading: false });
        return true;
    }
}
